module.exports = __webpack_public_path__ + "img/LogoH35-02.ca32bf26.png";